module.exports = __webpack_public_path__ + "static/media/Finnovex-Qatar-2024.400f0b79.png";